import type { AppRouteRecordRaw } from '@/router/types'

/**
 * 汽车会员收银（对齐 fuintCashierWeb）
 * - 与 views/car 同级：views/car-cashier
 * - 不走管理端 Layout，全屏独立（同 daike /cash）
 * - 登录态复用管理端 admin token
 *
 * 路径前缀：/car-cashier/*
 */
const carCashierRoutes: AppRouteRecordRaw[] = [
  {
    path: '/car-cashier',
    component: () => import('@/views/car-cashier/layout/index.vue'),
    redirect: '/car-cashier/home',
    name: 'CarCashierRoot',
    meta: { title: '汽车收银', hidden: true, noTagsView: true },
    children: [
      {
        path: 'home',
        component: () => import('@/views/car-cashier/home/index.vue'),
        name: 'CarCashierHome',
        meta: { title: '系统首页', hidden: true, noTagsView: true }
      },
      {
        path: 'cashier/index',
        component: () => import('@/views/car-cashier/cashier/index.vue'),
        name: 'CarCashierIndex',
        meta: { title: '收银台', hidden: true, noTagsView: true }
      },
      {
        path: 'setting/cashier',
        component: () => import('@/views/car-cashier/setting/cashier.vue'),
        name: 'CarCashierSetting',
        meta: { title: '系统设置', hidden: true, noTagsView: true }
      }
    ]
  }
]

export default carCashierRoutes
